import React from 'react';
import Slider from 'react-slick';
import './Certifications.css'; // Create a new CSS file for Certifications

// Sample certification data with images and links
const certifications = [
    {
        src: './CSPO.webp',
        alt: 'CSPO',
        link: 'https://bcert.me/bc/html/show-badge.html?b=dykzyzgi'
    },
    {
        src: './react.png',
        alt: 'React Certification',
        link: 'https://www.hackerrank.com/certificates/748868591059'
    },
    {
        src: './udemyaws.jpg',
        alt: 'AWS Udemy',
        link: 'https://udemy-certificate.s3.amazonaws.com/image/UC-1b5fefae-c2f5-4648-a390-9f1462e0fea6.jpg'
    },
];

const Certifications = () => {
    // Slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="certifications">
            <h2 data-aos="fade-right">Certifications</h2>
            <p data-aos="fade-up" data-aos-delay="200">Here are some of my certifications.</p>
            <Slider {...settings} className="certifications-carousel">
                {certifications.map((certification, index) => (
                    <a href={certification.link} target="_blank" rel="noopener noreferrer" key={index} className="certification-slide">
                        <img src={certification.src} alt={certification.alt} />
                    </a>
                ))}
            </Slider>
        </div>
    );
}

export default Certifications;